"use strict";
/**Selector que permite realizar un query al servidor cada vez que cambia el input */
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_rxk_1 = require("react-rxk");
const rx = require("rxjs");
const select_1 = require("./select");
const keautils_1 = require("keautils");
const loaditemsfunctions_1 = require("./loaditemsfunctions");
/**Devuelve una función que carga los elementos de un SelectQuery basado en un resource, es decir, en una función que obtiene un conjunto de elementos filtrados y en otra que obtiene un elemento dado su id.
 * La función query y get es memoizada
 * @param query Función que obtiene un conjunto de elementos dado el filtro
 * @param get Función que obtiene un elemento dado su valor
 * @param map Función que obtiene un @see SelectorElement dado un @see Item
 * @param includeValue Indica si para cierto filtro se deben de incluir en la lista los valores seleccionados. Esto va a implicar que se realizen los GET de los elementos seleccionados que no se encuentran en la lista
 */
function loadSelectorItemsFuncFromResource(query, get, map) {
    const retItems = loaditemsfunctions_1.loadItemsFuncFromResource(f => query(f.busqueda, f.filtro), get, x => map(x).value, x => x.busqueda == "");
    return function (busqueda, value, filtro) {
        const items = retItems({ busqueda, filtro }, value);
        return items.map(x => x.map(map));
    };
}
exports.loadSelectorItemsFuncFromResource = loadSelectorItemsFuncFromResource;
/**Convierte un valor o un arreglo de valores de un selector a un arreglo de un selector */
function valueToArray(value) {
    if (keautils_1.isArray(value)) {
        return value;
    }
    else {
        return value == null ? [] : [value];
    }
}
/**Select que permite realizar una petición cada vez que el usuario escribe en el filtro del select */
class SelectQueryView extends React.PureComponent {
    constructor(props) {
        super(props);
        this.inputChangeSubject = new rx.BehaviorSubject("");
        this.filterValueObs = this.inputChangeSubject.debounceTime(500).distinctUntilChanged();
        this.onInputChange = (filter) => {
            if (this.keydownFlag) {
                this.keydownFlag = false;
                this.inputChangeSubject.next(filter);
            }
        };
        this.handleOnInputKeyDown = (ev) => {
            //Establecemos el keyDwnFlag siempre y cuando no sea tab o enter
            const specialKeeys = [9, 10, 13, 37, 38, 39, 40];
            if (!keautils_1.contains(specialKeeys, ev.keyCode)) {
                this.keydownFlag = true;
            }
            else if (this.props.onInputKeyDown) {
                this.props.onInputKeyDown(ev);
            }
        };
        this.handleNextFilter = (busqueda) => {
            this.reloadItems(busqueda, this.props.value, this.props.filtro);
        };
        this.onChange = (value) => {
            if (value == null || (keautils_1.isArray(value) && value.length == 0)) {
                this.handleNextFilter("");
            }
            const onChange = this.props.onChange;
            if (onChange) {
                onChange(value);
            }
        };
        this.reloadOnValueChange = async (oldPropValues, nextPropValues, oldFiltro, nextFiltro) => {
            const oldValues = valueToArray(oldPropValues);
            const newValues = valueToArray(nextPropValues);
            //TODO: volver a obtener los items cuando cambie el valor, si es que el valor no se encuentra en la lista
            if (!keautils_1.shallowEquals(oldValues, newValues) || !keautils_1.shallowEquals(oldFiltro, nextFiltro)) {
                //Si cambio el valor, verificamos si existe alguno de los nuevos valores que no se encuentre en la lista actual, en ese caso habrá que actualizar el filtro
                const origProm = this.state.items;
                const items = (await origProm) || [];
                //Revisamos que no ha cambiado la promesa de items despues del await
                if (this.state.items !== origProm) {
                    return;
                }
                this.reloadItems(this.state.busqueda || "", nextPropValues, nextFiltro);
            }
        };
        this.state = {};
    }
    reloadItems(busqueda, value, filtro) {
        if (this.props.loadItems) {
            const loadItems = this.props.loadItems;
            const nextItems = loadItems(busqueda, value, filtro);
            this.setState({ items: nextItems, busqueda: busqueda });
        }
    }
    componentWillMount() {
        this.subscription = this.filterValueObs.subscribe(this.handleNextFilter);
    }
    componentWillUnmount() {
        this.subscription.unsubscribe();
    }
    componentWillReceiveProps(nextProps) {
        this.reloadOnValueChange(this.props.value, nextProps.value, this.props.filtro, nextProps.filtro);
    }
    render() {
        const props = keautils_1.omitUndefined(Object.assign({}, keautils_1.omit(this.props, ["loadItems"]), { onChange: this.onChange, onInputChange: this.onInputChange, onInputKeyDown: this.handleOnInputKeyDown, disableFiltering: true, items: this.state.items, loading: this.props.loading || undefined, onAgregar: this.props.onAgregar }));
        const comp = React.createElement(select_1.Select, Object.assign({}, props));
        return comp;
    }
}
exports.SelectQuery = react_rxk_1.componentToRx(SelectQueryView, undefined, undefined, {
    error: { ignore: { promise: true, observable: true } },
    loading: { loading: true }
});



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/selector/query.js
// module id = 2253
// module chunks = 0